export { };
declare global {
    interface Array<T> {
        last(): any;
        move(from: number, to: number): void;
    }
}

Array.prototype.last = function () {
    return this[this.length - 1];
};

Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};
